module.exports = __webpack_public_path__ + "edbcc27a3983fb975f29a54d7ac5fef6.jpg";